import { FunctionComponent } from "react";
import { VerificationDTO } from "../../../../../store/verification/models/dto/due-diligence";
import { useDueDiligenceKycType } from "../../../../../store/verification/models/internal";
import Chart from "./chart";
import KYB from "./kyb";
import Overview from "./overview";
import Participants from "./participants";

interface IFormEntriesProps {
  data: VerificationDTO.Responses.DueDiligence.Form.Get.T;
  configId: VerificationDTO.Responses.DueDiligence.Config.Get.T["id"];
}

const FormEntries: FunctionComponent<IFormEntriesProps> = ({
  data,
  configId,
}) => {
  const dueDiligenceTypes = useDueDiligenceKycType();

  return (
    <>
      <Overview item={data} configId={configId} />
      {data.kyb ? (
        <KYB
          item={data.kyb}
          attachments={data.attachments || []}
          dueDiligenceId={data.id}
        />
      ) : null}
      {data.participants?.length || data.kycs?.length ? (
        <Participants
          participants={data.participants}
          kycs={data.kycs}
          configId={configId}
        />
      ) : null}
      {data.kyb ? (
        <Chart
          kycs={data.kycs}
          participants={data.participants || []}
          kyb={data.kyb}
          dueDiligenceTypes={dueDiligenceTypes}
        />
      ) : null}
    </>
  );
};

export default FormEntries;
